export const ServiceCarrier = 'parcel'
